export const COLORS = {
  primary:      'var(--color-primary)',
  primaryHover: 'var(--color-primary-hover)',
  onPrimary:    'var(--color-on-primary)',
  accent:       'var(--color-accent)',
  bg:           'var(--color-bg)',
  white:        'var(--color-white)',
  surfaceHover: 'var(--color-surface-hover)',
  skeleton:     'var(--color-skeleton)',
  brandPanel:   'var(--color-brand-panel)',
  heroBg:       'var(--color-hero-bg)',
  heroBorder:   'var(--color-hero-border)',
  heroPillBg:   'var(--color-hero-pill-bg)',
  heroPillText: 'var(--color-hero-pill-text)',

  success:      'var(--color-success)',
  successBg:    'var(--color-success-bg)',
  successText:  'var(--color-success-text)',
  successBorder:'var(--color-success-border)',

  warning:      'var(--color-warning)',
  warningBg:    'var(--color-warning-bg)',
  warningText:  'var(--color-warning-text)',
  warningBorder:'var(--color-warning-border)',

  danger:       'var(--color-danger)',
  dangerBg:     'var(--color-danger-bg)',
  dangerText:   'var(--color-danger-text)',
  dangerBorder: 'var(--color-danger-border)',

  purple:       'var(--color-purple)',
  purpleBg:     'var(--color-purple-bg)',
  purpleText:   'var(--color-purple-text)',
  purpleBorder: 'var(--color-purple-border)',

  blue:         'var(--color-blue)',
  blueBg:       'var(--color-blue-bg)',
  blueText:     'var(--color-blue-text)',
  blueBorder:   'var(--color-blue-border)',

  textDark:     'var(--color-text-primary)',
  textMid:      'var(--color-text-mid)',
  textLight:    'var(--color-text-light)',
  border:       'var(--color-border)',
};

export const SHADOWS = {
  sm: 'var(--shadow-sm)',
  md: 'var(--shadow-md)',
  lg: 'var(--shadow-lg)',
};

export const FONTS = {
  display: "'Barlow Condensed', sans-serif",
  body:    "'DM Sans', sans-serif",
};
